import { useEffect, useState } from 'react';
import CustomerService from 'services/customer';
import DebtService from 'services/debt';
import { useApp } from 'contexts/app';
import dayjs from 'dayjs';
import _ from 'lodash';

const service = new CustomerService();
const debtService = new DebtService();

const useDebt = ({ customer, onChange }) => {
  const { showLoading, downloadPDF, sharePDF, copyPDF, printPdf } = useApp();

  const [lstDebt, setLstDebt] = useState([]);
  const [lstDebtFilled, setLstDebtFilled] = useState([]);
  const [updateDebt, setUpdateDebt] = useState({});
  const [debtFilter, setDebtFilter] = useState({ type: 'all', start: dayjs().add(-30, 'day') });
  const [debt, setDebt] = useState({ begin: 0, debt: 0, payment: 0, remain: 0 });

  useEffect(() => {
    if (customer?.id) {
      loadDebt();
    }
  }, [debtFilter.start, customer?.id]);

  // Apply type filter on lstDebt
  useEffect(() => {
    switch (debtFilter.type) {
      case 'has_remain_amount':
        setLstDebtFilled(lstDebt.filter((x) => x.type === 'debt' && x.remain_amount > 0));
        break;
      case 'debt':
        setLstDebtFilled(lstDebt.filter((x) => x.type === 'debt'));
        break;
      case 'payment':
        setLstDebtFilled(lstDebt.filter((x) => x.type === 'payment'));
        break;
      default:
        setLstDebtFilled([...lstDebt]);
        break;
    }
  }, [lstDebt, debtFilter.type]);

  const loadDebt = async () => {
    const data = await service.getDebt(customer.id, debtFilter.start);
    const debts = _.orderBy(data.debts, ['date', 'create_on'], ['desc', 'desc']);
    setLstDebt(debts);
    setDebt(data);
  };

  const showUpdateDebt = (debtId) => {
    setUpdateDebt({ isShow: true, id: debtId });
  };

  const closeUpdateDebt = () => {
    setUpdateDebt({ ...updateDebt, isShow: false });
  };

  const deleteDebt = async (debtID) => {
    showLoading(true);
    try {
      await debtService.delete(debtID);
      onChange();
    } finally {
      showLoading(false);
    }
  };

  const printDebt = async () => {
    showLoading(true);
    try {
      const data = await debtService.print(customer.id, debtFilter.start);
      if (data) printPdf(data.file, 'CongNo.pdf');
    } finally {
      showLoading(false);
    }
  };

  const shareDebtPDF = async () => {
    showLoading(true);
    try {
      const data = await debtService.print(customer.id, debtFilter.start);
      if (data) sharePDF(data.file, 'CongNo.pdf');
    } finally {
      showLoading(false);
    }
  };

  const copyDebtPDF = async () => {
    showLoading(true);
    try {
      const data = await debtService.print(customer.id, debtFilter.start);
      if (data) copyPDF(data.file, 'CongNo.pdf');
    } finally {
      showLoading(false);
    }
  };

  const onMenuClick = (e) => {
    switch (e.key) {
      case 'copy_pdf':
        copyDebtPDF();
        break;
      case 'share_pdf':
        shareDebtPDF();
        break;
      default:
        break;
    }
  };

  const setFilterType = (type) => setDebtFilter((prev) => ({ ...prev, type }));
  const setFilterStart = (date) => setDebtFilter((prev) => ({ ...prev, start: date.startOf('day') }));

  return {
    lstDebtFilled,
    updateDebt,
    debtFilter,
    debt,
    customer,
    onChange,
    showUpdateDebt,
    closeUpdateDebt,
    deleteDebt,
    printDebt,
    shareDebtPDF,
    copyDebtPDF,
    onMenuClick,
    setFilterType,
    setFilterStart,
  };
};

export default useDebt;
